
import {Component} from 'vue-property-decorator';
import CountryConditionsMixin from '../common/CountryConditionsMixin';
import CountryConditionItem from './components/CountryConditionItem.vue';

@Component({
    name: 'CountryConditions',
    components: {
        CountryConditionItem,
    },
})
export default class CountryConditionsComponent extends CountryConditionsMixin {
}
